module.exports = __webpack_public_path__ + "img/brand-08.00260c93.png";